<template>
  <div id="Agreement">
    <div class="TextTitle">上海瑞酷数码科技有限公司用户服务协议</div>
    <div class="Textpara">
      <p class="Textaction">一、特别提示</p>
      <p
        class="TextInfo"
      >1.1 上海瑞酷数码科技有限公司同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务(以下称“网络服务”)，为获得网络服务，服务使用人(以下称“用户”)同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。 本协议下的条款可由上海瑞酷数码科技有限公司随时变更，用户须定期审阅本协议。协议条款一旦发生变动，上海瑞酷数码科技有限公司将会在相关的页面上提示变更内容。变更后的协议在相关的页面上公布即有效代替原来的协议。用户如不同意上海瑞酷数码科技有限公司对本协议的所作的任何变更，应立即停止使用上海瑞酷数码科技有限公司提供的服务。如用户在本协议变更后继续使用上海瑞酷数码科技有限公司的服务，即视作用户已完全同意变更后的协议。用户在使用上海瑞酷数码科技有限公司提供的各项服务之前，应仔细阅读本服务协议，如用户不同意本服务协议及/或随时对其的修改，请停止使用上海瑞酷数码科技有限公司提供的服务。</p>
      <p class="Textaction">二、服务内容</p>
      <p
        class="TextInfo"
      >2.1 上海瑞酷数码科技有限公司服务的具体内容由上海瑞酷数码科技有限公司根据实际情况提供，例如论坛(BBS)、聊天室、电子邮件、发表新闻评论等。上海瑞酷数码科技有限公司保留随时变更、中止或终止部分或全部网络服务的权利。</p>
      <p
        class="TextInfo"
      >2.2 上海瑞酷数码科技有限公司在提供网络服务时，可能会对部分网络服务(例如网络游戏及其他电信增值服务)的用户收取一定的费用。在此情况下，上海瑞酷数码科技有限公司会在相关页面上做明确的提示。如用户不同意支付该等费用，则可不接受相关的网络服务。</p>
      <p
        class="TextInfo"
      >2.3 用户理解：上海瑞酷数码科技有限公司仅提供相关的网络服务，除此之外与相关网络服务有关的设备(如电脑、调制解调器及其他与接入互联网有关的装置)及所需的费用(如为接入互联网而支付的电话费及上网费)均应由用户自行负担。</p>
      <p class="TextInfo">2.4 用户应使用正版软件接受网络服务。</p>
      <p
        class="TextInfo"
      >2.5 上海瑞酷数码科技有限公司是专为无物流的文化和虚拟产品提供的数字发行平台，通过数据分发和支持系统、销售支付计费系统以及客户服务系统等，为用户获取数字内容产品提供优选渠道。用户理解上海瑞酷数码科技有限公司也会为其他互联网企业定制专业化的用户服务体系，即用户通过上海瑞酷数码科技有限公司获得的服务内容有可能来源于第三方企业，一旦用户接受该第三方企业提供的网络服务内容，则用户应当遵守该第三方企业对其服务做出的约定。如第三方企业接入上海瑞酷数码科技有限公司系统且其既有用户可以使用上海瑞酷数码科技有限公司提供的服务，则该既有用户即成为上海瑞酷数码科技有限公司的用户，其账号也自动成为上海瑞酷数码科技有限公司通行证账号。该既有用户同意亦将与在上海瑞酷数码科技有限公司系统中直接注册的用户一样遵守本协议的约定。但对于这些既有用户，上海瑞酷数码科技有限公司在服务过程中会仍然提供其已经熟悉的游戏账号充值界面，该过程仅为方便用户接受服务而设，既有用户与上海瑞酷数码科技有限公司之间的关系仍应受本协议的约定。</p>
      <p class="TextInfo">2.6 关于用户付费的特别提示：</p>
      <p
        class="TextInfo"
      >(A) 在上海瑞酷数码科技有限公司系统中，用户通过任何支付手段(包括但不限于使用支付宝或快钱工具进行的银行卡充值、手机卡充值等)为其账号充值所直接获得的均为“跳跃币”(或上海瑞酷数码科技有限公司系统更新发布的其他支付工具);</p>
      <p
        class="TextInfo"
      >(B) 跳跃币可以用于支付接入上海瑞酷数码科技有限公司系统的所有互联网应用及内容(包括第三方)的费用。一旦用户用其账号进入第三方企业的服务系统，则上海瑞酷数码科技有限公司会自动通过和第三方企业的技术合作，将该账号所剩余的跳跃币可以消费的该第三方系统自身的结算工具显示给用户;一旦用户退出该第三方服务系统，则在上海瑞酷数码科技有限公司系统中仍然可以显示尚未消费的跳跃币;</p>
      <p
        class="TextInfo"
      >(C) 为了尊重用户的消费习惯和符合用户体验习惯，用户在利用上海瑞酷数码科技有限公司系统提供的服务进行付费的过程中，可能出现直接获得其需要的第三方具体应用内容中的结算工具，而不是直接显示获得跳跃币的情况，用户理解并知晓上海瑞酷数码科技有限公司已经在后台技术系统内自动将跳跃币兑换为第三方系统自身的结算工具，用户为获取第三方具体应用内容而支付的费用均系通过第三方应用内容提供企业的自身系统的结算工具而非直接通过跳跃币进行结算的;</p>
      <p
        class="TextInfo"
      >(D) 第三方应用内容提供企业如果是网络游戏运营企业，则该第三方网络游戏运营企业可能会根据国家有关规定发行网络游戏虚拟货币，同时在游戏中设置游戏道具，用户可以根据自己的需要使用跳跃币。通常来说，在用户选择进入第三方网络游戏运营企业的系统后，上海瑞酷数码科技有限公司会自动将用户账号中剩余的跳跃币全部显示为可以消费的第三方网络游戏运营企业发行的网络游戏虚拟货币总量，跳跃币和它们的兑换比例将会明确公告给用户。即使用户可能感受到跳跃币和第三方网络游戏运营企业设置的游戏道具之间的直接存在对应关系，但在游戏程序之外的计费系统中，仍然是由跳跃币兑换成该第三方网络游戏运营企业发行的网络游戏虚拟货币，然后再将该网络游戏虚拟货币根据用户的需求转换为游戏内的道具。用户理解其对游戏道具的需求往往是消费的最终目的，上海瑞酷数码科技有限公司和第三方网络游戏运营企业合作对于付费过程的设置均为方便用户消费和符合用户体验习惯而设置，即使用户在整个消费第三方网络游戏运营企业过程中可能无法直接体验到其发行的网络游戏虚拟货币的存在，而事实上它们确实真实存在于网络游戏发行企业的系统中。</p>
      <p
        class="TextInfo"
      >(E) 用户理解并知晓，上海瑞酷数码科技有限公司不提供用户间交易跳跃币的平台化服务。用户间交易跳跃币系构成对本协议的违反，上海瑞酷数码科技有限公司有权在未经通知的情况下，采取相应适当措施，以确保上海瑞酷数码科技有限公司不提供用户间交易跳跃币的平台化服务。</p>
      <p class="TextInfo">2.7 上海瑞酷数码科技有限公司有权不定时地向用户发送业务公告等信息，通过邮件或短信等方式。若收到短信后不愿再接受类似消息，请回复TD。</p>
      <p class="Textaction">三、使用规则</p>
      <p
        class="TextInfo"
      >3.1 用户承诺以其真实身份注册成为上海瑞酷数码科技有限公司的用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法令规定和本协议约定对所提供的信息承担相应的法律责任。上海瑞酷数码科技有限公司有权审查用户注册所提供的身份信息是否真实、有效。用户以其真实身份注册成为上海瑞酷数码科技有限公司用户后，需要修改所提供的个人身份资料信息的，上海瑞酷数码科技有限公司应当及时、有效地为其提供该项服务。</p>
      <p
        class="TextInfo"
      >3.2 用户注册成功后，上海瑞酷数码科技有限公司将给予每个用户一个用户账号及相应的密码。该用户账号和密码由用户负责保管。用户有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码，并对登录后所持账号产生的行为依法享有权利和承担责任。上海瑞酷数码科技有限公司应积极地采取技术与管理等合理措施保障用户账号的安全、有效。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给用户和他人的民事权利造成损害的，应当承担由此产生的法律责任。</p>
      <p
        class="TextInfo"
      >3.3 用户发现其账号或密码被他人非法使用或有使用异常的情况的，应及时根据上海瑞酷数码科技有限公司公布的处理方式通知上海瑞酷数码科技有限公司，并有权通知上海瑞酷数码科技有限公司采取措施暂停该账号的登录和使用。上海瑞酷数码科技有限公司在收到用户要求采取措施暂停其账号登录和使用的通知后，应当要求用户提供并核实与其注册身份信息相一致的个人有效身份信息。上海瑞酷数码科技有限公司核实用户所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停用户账号的登录和使用。上海瑞酷数码科技有限公司违反前述约定，未及时采取措施暂停用户账号的登录和使用，因此而给用户造成损失的，应当承担其相应的法律责任。用户没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份信息不一致的，上海瑞酷数码科技有限公司有权拒绝用户前述请求。</p>
      <p
        class="TextInfo"
      >3.4 用户为了维护其合法权益，向上海瑞酷数码科技有限公司提供与所注册的身份信息相一致的个人有效身份信息时，上海瑞酷数码科技有限公司应当为用户提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。</p>
      <p class="TextInfo">3.5 用户同意接受上海瑞酷数码科技有限公司通过电子邮件或其他方式向用户发送的商品促销或其他相关商业信息。</p>
      <p class="TextInfo">3.6 用户在使用上海瑞酷数码科技有限公司服务过程中，必须遵循以下原则：</p>
      <p class="TextInfo">(A) 遵守中国有关的法律和法规;</p>
      <p class="TextInfo">(B) 不得为任何非法目的而使用网络服务系统;</p>
      <p class="TextInfo">(C) 遵守所有与网络服务有关的网络协议、规定和程序;</p>
      <p class="TextInfo">(D) 不得利用上海瑞酷数码科技有限公司服务系统进行任何可能对互联网的正常运转造成不利影响的行为;</p>
      <p class="TextInfo">(E) 不得利用上海瑞酷数码科技有限公司服务系统传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料;</p>
      <p class="TextInfo">(F) 不得利用上海瑞酷数码科技有限公司服务系统进行任何不利于上海瑞酷数码科技有限公司的行为;</p>
      <p
        class="TextInfo"
      >(G) 就上海瑞酷数码科技有限公司及合作商业伙伴的服务、产品、业务咨询应采取相应机构提供的沟通渠道，不得在公众场合发布有关上海瑞酷数码科技有限公司及相关服务的负面宣传</p>
      <p class="TextInfo">(H) 如发现任何非法使用用户账号或账号出现安全漏洞的情况，应立即通告上海瑞酷数码科技有限公司。</p>
      <p
        class="TextInfo"
      >3.7 用户使用根据本协议获得的用户账号和密码登录上海瑞酷数码科技有限公司的网站或接受其他上海瑞酷数码科技有限公司提供的服务项目时，应遵守该网站或服务项目的相关服务协议及使用守则，用户登录上述网站或接受上述服务项目时即视为对相关服务协议及使用守则的接受。</p>
      <p class="Textaction">四、内容所有权</p>
      <p class="TextInfo">4.1 上海瑞酷数码科技有限公司提供的网络服务内容可能包括：文字、软件、声音、图片、录象、图表等。所有这些内容受著作权法、商标法和其它法律法规的保护。</p>
      <p class="TextInfo">4.2 用户只有在获得上海瑞酷数码科技有限公司或其他相关权利人的书面授权之后才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。</p>
      <p class="Textaction">五、用户信息保护</p>
      <p
        class="TextInfo"
      >5.1 保护用户(特别是未成年人)的隐私是上海瑞酷数码科技有限公司的一项基本政策，因此，若父母(监护人)希望未成年人(尤其是十岁以下子女)得以使用本服务，必须以父母(监护人)名义申请注册，在接受本服务时，应以法定监护人身份加以判断本服务是否符合于未成年人。</p>
      <p
        class="TextInfo"
      >5.2在不透露单个用户隐私资料的前提下，上海瑞酷数码科技有限公司有权对整个用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。尽管上海瑞酷数码科技有限公司对用户的隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的技术信息等不受任何形式的损失。</p>
      <p
        class="TextInfo"
      >5.3未经用户许可上海瑞酷数码科技有限公司不得向任何第三方公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：</p>
      <p class="TextInfo">5.3.1 用户或用户监护人授权上海瑞酷数码科技有限公司披露的;</p>
      <p class="TextInfo">5.3.2 有关法令要求上海瑞酷数码科技有限公司披露的;</p>
      <p class="TextInfo">5.3.3 司法机关或行政机关基于法定程序要求上海瑞酷数码科技有限公司提供的;</p>
      <p class="TextInfo">5.3.4 上海瑞酷数码科技有限公司为了维护自己合法权益而向用户提起诉讼或者仲裁时;</p>
      <p class="TextInfo">5.3.5 应用户监护人的合法要求而提供用户个人身份信息时;</p>
      <p class="TextInfo">5.3.6 为维护社会公众的利益。</p>
      <p class="Textaction">六、免责声明</p>
      <p class="TextInfo">6.1五个字通行证所有者不保证以下事宜：</p>
      <p class="TextInfo">(i) 本服务将符合您的要求</p>
      <p class="TextInfo">(ii) 本服务将不受干扰、及时提供、安全可靠或不会出错。</p>
      <p
        class="TextInfo"
      >6.2 用户明确同意其使用上海瑞酷数码科技有限公司服务所存在的风险将完全由其自己承担;因其使用上海瑞酷数码科技有限公司服务而产生的一切后果也由其自己承担，上海瑞酷数码科技有限公司对用户不承担任何责任。</p>
      <p class="Textaction">七、服务变更、中断或终止</p>
      <p class="TextInfo">7.1 如因系统维护或升级的需要而需暂停网络服务，上海瑞酷数码科技有限公司将尽可能事先进行通告。</p>
      <p class="TextInfo">7.2 用户有发布违法信息、严重违背社会公德、以及其他违反法令禁止性规定的行为时，上海瑞酷数码科技有限公司有权立即终止对用户提供服务。</p>
      <p
        class="TextInfo"
      >7.3 用户在接受上海瑞酷数码科技有限公司服务时实施本协议中有明确约定或属于上海瑞酷数码科技有限公司事先明确告知的应被终止服务的禁止性行为的，上海瑞酷数码科技有限公司有权 终止对用户提供服务。</p>
      <p
        class="TextInfo"
      >7.4 用户提供虚假注册身份信息，或实施违反本协议的行为，上海瑞酷数码科技有限公司采取中止措施应当通知用户并告知中止期间，中止期间应该是合理的，中止期间届满上海瑞酷数码科技有限公司应当及时恢复对用户的服务。</p>
      <p class="TextInfo">7.5 上海瑞酷数码科技有限公司根据本条约定中止或终止对用户提供部分或全部服务的，上海瑞酷数码科技有限公司应负举证责任。</p>
      <p
        class="TextInfo"
      >7.6 除前款所述情形外，上海瑞酷数码科技有限公司同时保留在不事先通知用户的情况下随时中止或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，上海瑞酷数码科技有限公司无需对用户或任何第三方承担任何责任。</p>
      <p
        class="TextInfo"
      >7.7 如果您在注册五个字通行证后连续6个月时间内，没有使用过此五个字通行证(包括使用此五个字通行证登录游戏，登录网站，充值)，则该五个字通行证不会被系统保留。</p>
      <p class="Textaction">八、违约赔偿</p>
      <p
        class="TextInfo"
      >8.1 用户同意保障和维护上海瑞酷数码科技有限公司及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给上海瑞酷数码科技有限公司或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。</p>
      <p class="Textaction">九、法律管辖</p>
      <p class="TextInfo">9.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</p>
      <p class="TextInfo">9.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决;协商不成时，任何一方均应向上海市闵行区的人民法院提起诉讼。</p>
      <p class="Textaction">十、通知和送达</p>
      <p class="TextInfo">10.1 本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行;该等通知于发送之日视为已送达收件人。</p>
      <p class="Textaction">十一、其他规定</p>
      <p class="TextInfo">11.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
      <p class="TextInfo">11.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
      <p class="TextInfo">11.3 本协议中的标题仅为方便而设，不具法律或契约效果。</p>
      <p class="Textaction">特 别 声 明</p>
      <p
        class="TextInfo"
      >鉴于：我国《合同法》第39条规定：采用格式条款订立合同的，提供格式条款的一方应当遵循公平原则确定当事人之间的权利和义务，并采取合理的方式提请对方注意免除或者限制其责任的条款，按照对方的要求，对该条款予以说明。</p>
      <p class="TextInfo">上海瑞酷数码科技有限公司在此依法做出特别声明如下：</p>
      <p
        class="TextInfo"
      >上海瑞酷数码科技有限公司采取合理的方式提请用户注意的义务将通过如下方式实现：在本协议中上海瑞酷数码科技有限公司以明确的足以引起用户注意的加重字体、斜体、下划线、颜色标记等合理方式提醒用户注意相关条款(需要强调的是，还包括用户应特别注意任何未明确标记的含有“不承担”、“免责”“不得”等形式用语的条款)，该等条款的确认将导致用户在特定情况下的被动、不便、损失，请用户在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款，上海瑞酷数码科技有限公司尊重用户的权利尤其是诉讼的权利，但作为全球运营的公司，上海瑞酷数码科技有限公司在尊重用户诉讼权利的同时建议诉讼管辖地法院为上海瑞酷数码科技有限公司所在地法院，而用户选择同意合同并使用服务即视为双方对此约定达成了一致意见。</p>
      <p
        class="TextInfo"
      >用户如有任何需要说明条款的要求，请立即停止使用服务，同时立即发送邮件至kefu@tsapk.com，若用户未致电或发送有说明条款要求的邮件至上海瑞酷数码科技有限公司而选择同意该协议，则双方在此确认上海瑞酷数码科技有限公司已依法履行了根据用户要求对相关条款进行说明的法定义务，上海瑞酷数码科技有限公司已给予用户充足的时间与充分的选择权来决定是否缔结本协议。</p>
      <p
        class="TextInfo"
      >鉴于上海瑞酷数码科技有限公司已依法明确了上述条款、履行了格式条款制订方的义务，用户点击同意或下一步，将被视为且应当被视为用户已经完全注意并同意了本协议所有条款尤其是提醒用户注意的条款的合法性及有效性，用户不应当以上海瑞酷数码科技有限公司未对格式条款以合理方式提醒用户注意，或未根据用户要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Agreement",
  data() {
    return {};
  },
  components: {}
};
</script>
<style lang="stylus" scoped>
@import '../Common/common.styl';

#Agreement {
  width: 100%;
  paddingPage(); 
  cardStyle();
}
</style>



// WEBPACK FOOTER //
// src/components/About/Agreement.vue